import { useEffect, useState } from "react";
import { Menu, X, Plane } from "lucide-react";
import { NAV_LINKS } from "../mock";

export const Navigation = ({ onCtaClick }) => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <nav
      data-testid="primary-nav"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "backdrop-blur-xl bg-[#0A1128]/80 border-b border-white/10"
          : "backdrop-blur-md bg-transparent border-b border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-5 flex items-center justify-between">
        {/* Brand */}
        <a
          href="#top"
          data-testid="nav-brand"
          className="flex items-center gap-3 group"
        >
          <span className="relative flex h-9 w-9 items-center justify-center border border-[#C19A5D]/60 bg-[#0A1128]">
            <Plane className="h-4 w-4 text-[#C19A5D]" strokeWidth={1.5} />
            <span className="absolute -bottom-0.5 -right-0.5 h-1.5 w-1.5 bg-[#C19A5D] pulse-dot rounded-full" />
          </span>
          <span className="font-heading text-lg font-semibold tracking-tight">
            Omni<span className="text-[#C19A5D]">Link</span>
          </span>
        </a>

        {/* Desktop links */}
        <div className="hidden md:flex items-center gap-9">
          {NAV_LINKS.map((l) => (
            <a
              key={l.id}
              href={l.href}
              data-testid={l.id}
              className="link-underline text-sm text-white/70 hover:text-white transition-colors"
            >
              {l.label}
            </a>
          ))}
        </div>

        {/* CTA */}
        <div className="hidden md:flex items-center gap-3">
          <button
            data-testid="nav-cta-demo"
            onClick={onCtaClick}
            className="bg-[#C19A5D] text-[#050814] hover:bg-[#D4AF74] transition-all duration-300 px-6 py-3 font-semibold uppercase tracking-wider text-xs"
          >
            Request Demo
          </button>
        </div>

        {/* Mobile toggle */}
        <button
          data-testid="nav-mobile-toggle"
          className="md:hidden text-white/80"
          onClick={() => setOpen((s) => !s)}
          aria-label="Toggle menu"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {/* Mobile panel */}
      {open && (
        <div
          data-testid="nav-mobile-panel"
          className="md:hidden border-t border-white/10 bg-[#0A1128]/95 backdrop-blur-xl"
        >
          <div className="px-6 py-6 flex flex-col gap-5">
            {NAV_LINKS.map((l) => (
              <a
                key={l.id}
                href={l.href}
                data-testid={`${l.id}-mobile`}
                onClick={() => setOpen(false)}
                className="text-white/80 text-base"
              >
                {l.label}
              </a>
            ))}
            <button
              data-testid="nav-cta-demo-mobile"
              onClick={() => {
                setOpen(false);
                onCtaClick?.();
              }}
              className="mt-2 bg-[#C19A5D] text-[#050814] hover:bg-[#D4AF74] transition-all duration-300 px-6 py-3 font-semibold uppercase tracking-wider text-xs"
            >
              Request Demo
            </button>
          </div>
        </div>
      )}
    </nav>
  );
};
